module.exports = __webpack_public_path__ + "3fda77c57c3154a763a8635109d6df49.png";